import { Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { FC } from 'react';
import { IRules } from '../../interfaces/campaign';

interface CampaignRulesProps {
	rules: IRules | undefined;
}

const CampaignRules: FC<CampaignRulesProps> = ({ rules }) => {
	return (
		<>
			{rules && rules.media && (
				<>
					<Box className="my-4 flex rounded-md border border-dashed border-grey-300 bg-grey-100 px-6 py-4">
						<InfoIcon className="me-2 h-6 w-6 text-grey-600" />
						<Box className="text-sm leading-7 text-text-secondary">
							<ol className="ps-2 text-text-primary">{rules.media?.map((rule, i) => <li key={i}>{rule}</li>)}</ol>
						</Box>
					</Box>
				</>
			)}
			{rules && rules.media_entity && rules.media_type && (rules.media_entity.length > 0 || rules.media_type.length > 0) && (
				<Box className={`mb-6 flex rounded-md border border-dashed border-primary-main bg-info-hover px-6 py-4`}>
					<InfoIcon className="me-2 h-6 w-6 text-primary-main" />
					<Box className="leading-7 text-primary-main">
						<ol className="ps-2 text-text-primary">{rules?.media_entity && Array.isArray(rules?.media_entity) && rules.media_entity.length > 0 && rules.media_entity?.map(rule => rule?.map((item: string, index: number) => <li key={index}>{item}</li>))}</ol>
						<ol className="ps-2 text-text-primary">{rules.media_type?.map((rule, i) => <li key={i}>{rule}</li>)}</ol>
					</Box>
				</Box>
			)}
		</>
	);
};

export default CampaignRules;
